import {useSignal} from "@preact/signals-react";
import {useCallback} from "react";

export default function usePriceEvolutionChart() {
	const useActualPrice = useSignal(true)
	const showLegend = useSignal(true)
	const showRRSP = useSignal(false)

	const handleChangePrice = useCallback(newValue => {
		useActualPrice.value = newValue
	}, [])

	const handleChangeLegend = useCallback(newValue => {
		showLegend.value = newValue
	}, [])

	const handleChangeShowRRSP = useCallback(newValue => {
		showRRSP.value = newValue
	}, [])

	return {
		useActualPrice: useActualPrice.value,
		showLegend: showLegend.value,
		showRRSP: showRRSP.value,

		handleChangePrice,
		handleChangeLegend,
		handleChangeShowRRSP
	}
}